import { IoMdMore } from "react-icons/io";
import { BsCash, BsCashCoin } from "react-icons/bs";
//import { HiArrowNarrowLeft } from "react-icons/hi";
import { FaMoneyBillTransfer, FaMoneyBillTrendUp } from "react-icons/fa6";

import { GiSandsOfTime } from "react-icons/gi";
import { MdSmsFailed } from "react-icons/md";
import { useSelector } from "react-redux";
import { RootState } from "@/store/type";
import { useEffect, useState } from "react";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  TextField,
  Typography,
  Card,
  CardContent,
  Chip,
  IconButton,
  useMediaQuery,
  Theme,
  Grid,
  Alert,
  CircularProgress,
} from "@mui/material";
import { UploadFile } from "@mui/icons-material";
import { FileUploader } from "react-drag-drop-files";
import { useTranslate } from "@/locales";
import { useLocale } from "@/middleware";
import useTransform from "@/hooks/use-transform";
import { showToast } from "@/app/global-components/toaster";
import { LANG } from "@/types";

interface Transformation {
  id: string;
  title: string;
  status: "Pending" | "Accepted" | "Refused";
  buyerId: string;
  sellerId: string;
  userId: string;
  orderId: string;
  totalPrice: number;
  transformRequest: boolean;
  withdrawRequest: boolean;
  createdAt: Date;
}

interface BankAccount {
  accountName?: string;
  accountNumber?: string;
  bankName?: string | null;
  iban?: string;
}

function LandingPaymentBuyer() {
  const { locale } = useLocale();
  const { t } = useTranslate(locale);
  const isMobile = useMediaQuery((theme: Theme) =>
    theme.breakpoints.down("sm")
  );
  const isTablet = useMediaQuery((theme: Theme) =>
    theme.breakpoints.down("md")
  );

  const [AvailableCount, setAvailableCount] = useState(0);
  const [PendingValue, setPendingValue] = useState(0);
  const [TransformedValue, setTransformedValue] = useState(0);
  const [transformations, setTransformations] = useState<Transformation[]>([]);
  const [withdrawAmount, setWithdrawAmount] = useState(0);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [isPopup1Open, setIsPopup1Open] = useState(false);
  const [loading, setLoading] = useState(false);
  const [bankAccount, setBankAccount] = useState<BankAccount>({
    accountName: "",
    accountNumber: "",
    bankName: "",
    iban: "",
  });

  const bankInfo = {
    accountName: "شركة ميدا المتقدمة لحلول الاعمال",
    accountNumber: "212000010006086127973",
    iban: "SA0780000212608016127973",
    bankName: "بنك الراجحي",
  };

  const myCompany = useSelector((state: RootState) => state.auth.myCompany);
  const { fetchTransforms, upsertTransform } = useTransform();
  const [uploadedFile, setUploadedFile] = useState<File | null>(null);

  const handleOpenPopup = () => setIsPopupOpen(true);
  const handleClosePopup = () => setIsPopupOpen(false);
  // const handleConfirmOpenPopup = () => setIsPopup1Open(true);
  const handleClosePopup2 = () => setIsPopup1Open(false);

  const handleBankAccountChange = (field: keyof BankAccount, value: string) => {
    setBankAccount((prev) => ({ ...prev, [field]: value }));
  };

  const handleFileUpload = (file: File) => {
    setUploadedFile(file);
  };

  const handleCreateAdd = async () => {
    if (withdrawAmount <= 0) {
      showToast(t("Alert.EnterValidAmount"), "warning");
      return;
    }

    if (!uploadedFile) {
      showToast(t("Alert.UploadTransferProof"), "warning");
      return;
    }

    setLoading(true);
    try {
      const transformationPayload = {
        title: "Transfer",
        status: "Pending",
        buyerId: myCompany.id,
        withdrawRequest: false,
        transformRequest: false,
        type: "Transfer",
        totalPrice: withdrawAmount,
        attachment: uploadedFile,
      };

      const response = await upsertTransform(transformationPayload);
      if (response.isSuccess) {
        showToast(t("Alert.TransactionCreated"), "success");
        handleClosePopup2();
        await loadItems();
      } else {
        showToast(
          response.message || t("Alert.TransactionCreationFailed"),
          "warning"
        );
      }
    } catch (error) {
      console.error("Error creating transformation:", error);
      showToast(t("Alert.TransactionErrorTryAgain"), "warning");
    } finally {
      setLoading(false);
    }
  };

  const handleCreateTransform = async () => {
    if (withdrawAmount > AvailableCount) {
      showToast(t("Alert.WithdrawExceedsBalance"), "warning");
      return;
    }

    setLoading(true);
    try {
      let bank = [];
      bank.push(bankAccount);
      const transformationPayload = {
        title: "Withdraw",
        status: "Pending",
        buyerId: myCompany.id,
        withdrawRequest: false,
        bankAccount: JSON.stringify(bank),
        type: "withdraw",
        totalPrice: withdrawAmount,
      };

      const response = await upsertTransform(transformationPayload);
      if (response.isSuccess) {
        showToast(t("Alert.WithdrawCreated"), "success");
        handleClosePopup();
        await loadItems();
      } else {
        showToast(response.message || t("Alert.WithdrawFailed"), "warning");
      }
    } catch (error) {
      showToast(t("Alert.WithdrawErrorTryAgain"), "warning");
      console.error("Error creating transformation:", error);
    } finally {
      setLoading(false);
    }
  };

  const loadItems = async () => {
    try {
      const response = await fetchTransforms({
        buyerId: myCompany.id,
        pageSize: 10,
        pageNumber: 0,
        withPaging: false,
      });
      const transforms = response?.data || [];
      setTransformations(transforms);

      const total = transforms.reduce(
        (sum: number, t: Transformation) => sum + t.totalPrice,
        0
      );
      const pending = transforms
        .filter((t: Transformation) => t.status === "Pending")
        .reduce((sum: number, t: Transformation) => sum + t.totalPrice, 0);
      const transformed = transforms
        .filter((t: Transformation) => t.withdrawRequest)
        .reduce((sum: number, t: Transformation) => sum + t.totalPrice, 0);

      setAvailableCount(total - pending - transformed);
      setPendingValue(pending);
      setTransformedValue(transformed);
    } catch (error) {
      console.error("Error fetching transformations:", error);
    }
  };

  useEffect(() => {
    if (myCompany) {
      loadItems();
    }
  }, [myCompany]);

  const getStatusChip = (status: string) => {
    const statusConfig = {
      Pending: {
        color: "#f59e0b",
        bgColor: "#fef3c7",
        icon: <GiSandsOfTime size={16} />,
      },
      Accepted: {
        color: "#10b981",
        bgColor: "#d1fae5",
        icon: <BsCashCoin size={16} />,
      },
      Refused: {
        color: "#ef4444",
        bgColor: "#fee2e2",
        icon: <MdSmsFailed size={16} />,
      },
    };

    const config =
      statusConfig[status as keyof typeof statusConfig] || statusConfig.Pending;

    return (
      <Chip
        icon={config.icon}
        label={status}
        size="small"
        sx={{
          backgroundColor: config.bgColor,
          color: config.color,
          fontWeight: 600,
          fontSize: "0.75rem",
        }}
      />
    );
  };

  return (
    <Box
      dir={locale === LANG.EN ? "ltr" : "rtl"}
      sx={{
        py: { xs: 2, sm: 3, md: 4 },
        px: { xs: 1, sm: 2, md: 3 },
        backgroundColor: "#fafafa",
        minHeight: "100vh",
      }}
    >
      {/* Header */}
      <Box sx={{ mb: { xs: 2, sm: 3, md: 4 } }}>
        <Typography
          variant="h4"
          sx={{
            fontSize: { xs: "1.25rem", sm: "1.5rem", md: "2rem" },
            fontWeight: 600,
            color: "#1f2937",
            mb: 1,
          }}
        >
          {t("wallet.details")}
        </Typography>
      </Box>

      {/* Wallet Cards */}
      <Grid container spacing={2} sx={{ mb: { xs: 2, sm: 3, md: 4 } }}>
        <Grid item xs={12} sm={6} md={4}>
          <Card
            sx={{
              height: { xs: 120, sm: 140, md: 160 },
              backgroundColor: "#ffffff",
              borderRadius: 2,
              boxShadow: "none",
            }}
          >
            <CardContent
              sx={{
                p: { xs: 2, sm: 2.5, md: 3 },
                height: "100%",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
                <Box
                  sx={{
                    width: { xs: 32, sm: 36, md: 40 },
                    height: { xs: 32, sm: 36, md: 40 },
                    borderRadius: "50%",
                    backgroundColor: "#f3f4f6",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    mr: 1,
                  }}
                >
                  <BsCash
                    size={isMobile ? 16 : isTablet ? 18 : 20}
                    color="#6b7280"
                  />
                </Box>
                <Typography
                  variant="body2"
                  sx={{
                    fontSize: { xs: "0.75rem", sm: "0.875rem" },
                    color: "#6b7280",
                    fontWeight: 500,
                  }}
                >
                  {t("wallet.currentBalance")}
                </Typography>
              </Box>

              <Typography
                variant="h5"
                sx={{
                  fontSize: { xs: "1.25rem", sm: "1.5rem", md: "1.75rem" },
                  fontWeight: 700,
                  color: "#1f2937",
                  mb: "auto",
                }}
              >
                {AvailableCount} {t("currency")}
              </Typography>
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12} sm={6} md={4}>
          <Card
            sx={{
              height: { xs: 120, sm: 140, md: 160 },
              backgroundColor: "#ffffff",
              borderRadius: 2,
              boxShadow: "none",
              transition: "box-shadow 0.2s ease",
            }}
          >
            <CardContent
              sx={{
                p: { xs: 2, sm: 2.5, md: 3 },
                height: "100%",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
                <Box
                  sx={{
                    width: { xs: 32, sm: 36, md: 40 },
                    height: { xs: 32, sm: 36, md: 40 },
                    borderRadius: "50%",
                    backgroundColor: "#f3f4f6",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    mr: 1,
                  }}
                >
                  <FaMoneyBillTrendUp
                    size={isMobile ? 16 : isTablet ? 18 : 20}
                    color="#6b7280"
                  />
                </Box>
                <Typography
                  variant="body2"
                  sx={{
                    fontSize: { xs: "0.75rem", sm: "0.875rem" },
                    color: "#6b7280",
                    fontWeight: 500,
                  }}
                >
                  {t("status.underReview")}
                </Typography>
              </Box>

              <Typography
                variant="h5"
                sx={{
                  fontSize: { xs: "1.25rem", sm: "1.5rem", md: "1.75rem" },
                  fontWeight: 700,
                  color: "#1f2937",
                  mb: "auto",
                }}
              >
                {PendingValue} {t("currency")}
              </Typography>
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12} sm={6} md={4}>
          <Card
            sx={{
              height: { xs: 120, sm: 140, md: 160 },
              backgroundColor: "#ffffff",
              borderRadius: 2,
              boxShadow: "none",
              transition: "box-shadow 0.2s ease",
            }}
          >
            <CardContent
              sx={{
                p: { xs: 2, sm: 2.5, md: 3 },
                height: "100%",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
                <Box
                  sx={{
                    width: { xs: 32, sm: 36, md: 40 },
                    height: { xs: 32, sm: 36, md: 40 },
                    borderRadius: "50%",
                    backgroundColor: "#f3f4f6",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    mr: 1,
                  }}
                >
                  <FaMoneyBillTransfer
                    size={isMobile ? 16 : isTablet ? 18 : 20}
                    color="#6b7280"
                  />
                </Box>
                <Typography
                  variant="body2"
                  sx={{
                    fontSize: { xs: "0.75rem", sm: "0.875rem" },
                    color: "#6b7280",
                    fontWeight: 500,
                  }}
                >
                  {t("wallet.withdrawnMoney")}
                </Typography>
              </Box>

              <Typography
                variant="h5"
                sx={{
                  fontSize: { xs: "1.25rem", sm: "1.5rem", md: "1.75rem" },
                  fontWeight: 700,
                  color: "#1f2937",
                  mb: "auto",
                }}
              >
                {TransformedValue} {t("currency")}
              </Typography>
            </CardContent>
          </Card>
        </Grid>
      </Grid>

      <Card sx={{ borderRadius: 2, boxShadow: "none" }}>
        <CardContent sx={{ p: { xs: 2, sm: 3 } }}>
          <Box
            sx={{
              display: "flex",
              flexDirection: { xs: "column", sm: "row" },
              justifyContent: "space-between",
              alignItems: { xs: "stretch", sm: "center" },
              mb: 3,
              gap: 2,
            }}
          >
            <Typography
              variant="h6"
              sx={{
                fontSize: { xs: "1.125rem", sm: "1.25rem" },
                fontWeight: 600,
                color: "#1f2937",
              }}
            >
              {t("wallet.transferHistory")}
            </Typography>
            <Button
              variant="contained"
              onClick={handleOpenPopup}
              sx={{
                backgroundColor: "#644980",
                color: "white",
                borderRadius: 1.5,
                px: 3,
                py: 1,
                fontSize: { xs: "0.875rem", sm: "1rem" },
                "&:hover": {
                  backgroundColor: "#644980",
                },
              }}
            >
              {t("actions.withdraw")}
            </Button>
          </Box>

          {/* Mobile Table */}
          {isMobile ? (
            <Box>
              {transformations.length === 0 ? (
                <Box sx={{ textAlign: "center", py: 4 }}>
                  <Typography variant="body1" sx={{ color: "#6b7280" }}>
                    {t("general.NoDataAvailable")}
                  </Typography>
                </Box>
              ) : (
                transformations.map((transform, index) => (
                  <Card
                    key={index}
                    sx={{
                      mb: 2,
                      p: 2,
                      border: "1px solid #e5e7eb",
                      borderRadius: 2,
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        mb: 1,
                      }}
                    >
                      <Typography
                        variant="body2"
                        sx={{ color: "#6b7280", fontSize: "0.75rem" }}
                      >
                        {new Date(transform.createdAt).toLocaleDateString()}
                      </Typography>
                      {getStatusChip(transform.status)}
                    </Box>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <Typography
                        variant="body2"
                        sx={{ fontWeight: 600, color: "#1f2937" }}
                      >
                        {transform.totalPrice} {t("currency")}
                      </Typography>
                      <IconButton size="small" sx={{ color: "#6b7280" }}>
                        <IoMdMore />
                      </IconButton>
                    </Box>
                  </Card>
                ))
              )}
            </Box>
          ) : (
            /* Desktop Table */
            <Box>
              {/* Table Header */}
              <Box
                sx={{
                  display: "grid",
                  gridTemplateColumns: "1fr 1fr 1fr 80px",
                  gap: 2,
                  p: 2,
                  backgroundColor: "#f9fafb",
                  borderRadius: 1,
                  mb: 2,
                  border: "1px solid #e5e7eb",
                }}
              >
                <Typography
                  variant="subtitle2"
                  sx={{
                    fontWeight: 600,
                    color: "#374151",
                    fontSize: "0.875rem",
                  }}
                >
                  {t("wallet.date")}
                </Typography>
                <Typography
                  variant="subtitle2"
                  sx={{
                    fontWeight: 600,
                    color: "#374151",
                    fontSize: "0.875rem",
                  }}
                >
                  {t("orders.fields.status")}
                </Typography>
                <Typography
                  variant="subtitle2"
                  sx={{
                    fontWeight: 600,
                    color: "#374151",
                    fontSize: "0.875rem",
                  }}
                >
                  {t("wallet.amount")}
                </Typography>
                <Typography
                  variant="subtitle2"
                  sx={{
                    fontWeight: 600,
                    color: "#374151",
                    fontSize: "0.875rem",
                  }}
                >
                  {t("navigation.Settings")}
                </Typography>
              </Box>

              {/* Table Body */}
              <Box sx={{ maxHeight: 400, overflowY: "auto" }}>
                {transformations.length === 0 ? (
                  <Box sx={{ textAlign: "center", py: 4 }}>
                    <Typography variant="body1" sx={{ color: "#6b7280" }}>
                      {t("general.NoDataAvailable")}
                    </Typography>
                  </Box>
                ) : (
                  transformations.map((transform, index) => (
                    <Box
                      key={index}
                      sx={{
                        display: "grid",
                        gridTemplateColumns: "1fr 1fr 1fr 80px",
                        gap: 2,
                        p: 2,
                        borderBottom: "1px solid #e5e7eb",
                        "&:hover": {
                          backgroundColor: "#f9fafb",
                        },
                        transition: "background-color 0.2s ease",
                      }}
                    >
                      <Typography
                        variant="body2"
                        sx={{ color: "#374151", fontSize: "0.875rem" }}
                      >
                        {new Date(transform.createdAt).toLocaleDateString()}
                      </Typography>
                      <Box>{getStatusChip(transform.status)}</Box>
                      <Typography
                        variant="body2"
                        sx={{
                          fontWeight: 600,
                          color: "#1f2937",
                          fontSize: "0.875rem",
                        }}
                      >
                        {transform.totalPrice} {t("currency")}
                      </Typography>
                      <IconButton size="small" sx={{ color: "#6b7280" }}>
                        <IoMdMore />
                      </IconButton>
                    </Box>
                  ))
                )}
              </Box>
            </Box>
          )}
        </CardContent>
      </Card>

      {/* Add Balance Dialog */}
      <Dialog
        open={isPopup1Open}
        onClose={handleClosePopup2}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 2,
            m: { xs: 2, sm: 3 },
          },
        }}
      >
        <DialogTitle
          sx={{ backgroundColor: "#f9fafb", borderBottom: "1px solid #e5e7eb" }}
        >
          <Typography variant="h6" sx={{ fontWeight: 600, color: "#1f2937" }}>
            {t("actions.addBalance")}
          </Typography>
        </DialogTitle>
        <DialogContent sx={{ p: 3 }}>
          <Alert severity="info" sx={{ mb: 3, borderRadius: 1 }}>
            <Typography variant="body2">
              <strong>{t("orders.fields.totalPrice")}:</strong> {AvailableCount}{" "}
              {t("currency")}
            </Typography>
          </Alert>

          <Divider sx={{ mb: 3 }} />

          <Typography
            variant="subtitle1"
            sx={{ mb: 2, fontWeight: 600, color: "#1f2937" }}
          >
            {t("payment.bankInfo")}
          </Typography>

          <Box
            sx={{ backgroundColor: "#f9fafb", p: 2, borderRadius: 1, mb: 3 }}
          >
            <Typography variant="body2" sx={{ mb: 1 }}>
              <strong>{t("payment.accountName")}:</strong>{" "}
              {bankInfo.accountName}
            </Typography>
            <Typography variant="body2" sx={{ mb: 1 }}>
              <strong>{t("payment.accountNumber")}:</strong>{" "}
              {bankInfo.accountNumber}
            </Typography>
            <Typography variant="body2" sx={{ mb: 1 }}>
              <strong>{t("payment.iban")}:</strong> {bankInfo.iban}
            </Typography>
            <Typography variant="body2">
              <strong>{t("payment.bankName")}:</strong> {bankInfo.bankName}
            </Typography>
          </Box>

          <Divider sx={{ mb: 3 }} />

          <Typography
            variant="subtitle1"
            sx={{ mb: 2, fontWeight: 600, color: "#1f2937" }}
          >
            {t("payment.uploadTransferImage")}
          </Typography>

          <Box sx={{ mb: 3 }}>
            <FileUploader
              handleChange={handleFileUpload}
              name="file"
              types={["jpg", "png", "pdf"]}
              maxSize={5}
              label={t("general.DragOrClickToUpload")}
            />
            {uploadedFile && (
              <Box
                sx={{ display: "flex", alignItems: "center", gap: 1, mt: 1 }}
              >
                <UploadFile sx={{ color: "#644980" }} />
                <Typography variant="body2">{uploadedFile.name}</Typography>
              </Box>
            )}
          </Box>

          <Typography
            variant="subtitle1"
            sx={{ mb: 2, fontWeight: 600, color: "#1f2937" }}
          >
            {t("wallet.amountToAdd")}
          </Typography>

          <TextField
            fullWidth
            size="small"
            type="number"
            value={withdrawAmount}
            onChange={(e) => setWithdrawAmount(Number(e.target.value))}
            sx={{
              "& .MuiOutlinedInput-root": {
                borderRadius: 1,
                "&:hover": {
                  "& .MuiOutlinedInput-notchedOutline": {
                    borderColor: "#644980",
                  },
                },
                "&.Mui-focused": {
                  "& .MuiOutlinedInput-notchedOutline": {
                    borderColor: "#644980",
                    borderWidth: 2,
                  },
                },
              },
            }}
          />
        </DialogContent>
        <DialogActions sx={{ p: 3, gap: 2 }}>
          <Button
            variant="outlined"
            onClick={handleClosePopup2}
            sx={{ borderRadius: 1.5 }}
          >
            {t("actions.cancel")}
          </Button>
          <Button
            variant="contained"
            onClick={handleCreateAdd}
            disabled={!uploadedFile || withdrawAmount <= 0 || loading}
            sx={{
              backgroundColor: "#644980",
              borderRadius: 1.5,
              px: 3,
              "&:hover": {
                backgroundColor: "#644980",
              },
              "&:disabled": {
                backgroundColor: "#e5e7eb",
                color: "#9ca3af",
              },
            }}
          >
            {loading ? (
              <CircularProgress size={20} color="inherit" />
            ) : (
              t("actions.save")
            )}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Add Bank Account Dialog */}
      <Dialog
        open={isPopupOpen}
        onClose={handleClosePopup}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 2,
            m: { xs: 2, sm: 3 },
          },
        }}
      >
        <DialogTitle
          sx={{ backgroundColor: "#f9fafb", borderBottom: "1px solid #e5e7eb" }}
        >
          <Typography variant="h6" sx={{ fontWeight: 600, color: "#1f2937" }}>
            {t("actions.addBankAccount")}
          </Typography>
        </DialogTitle>
        <DialogContent sx={{ p: 3 }}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Typography
                variant="subtitle2"
                sx={{ mb: 1, fontWeight: 600, color: "#374151" }}
              >
                {t("payment.accountName")}
              </Typography>
              <TextField
                fullWidth
                size="small"
                value={bankAccount.accountName}
                onChange={(e) =>
                  handleBankAccountChange("accountName", e.target.value)
                }
                sx={{
                  "& .MuiOutlinedInput-root": {
                    borderRadius: 1,
                    "&:hover": {
                      "& .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#644980",
                      },
                    },
                    "&.Mui-focused": {
                      "& .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#644980",
                        borderWidth: 2,
                      },
                    },
                  },
                }}
              />
            </Grid>

            <Grid item xs={12}>
              <Typography
                variant="subtitle2"
                sx={{ mb: 1, fontWeight: 600, color: "#374151" }}
              >
                {t("payment.accountNumber")}
              </Typography>
              <TextField
                fullWidth
                size="small"
                value={bankAccount.accountNumber}
                onChange={(e) =>
                  handleBankAccountChange("accountNumber", e.target.value)
                }
                sx={{
                  "& .MuiOutlinedInput-root": {
                    borderRadius: 1,
                    "&:hover": {
                      "& .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#644980",
                      },
                    },
                    "&.Mui-focused": {
                      "& .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#644980",
                        borderWidth: 2,
                      },
                    },
                  },
                }}
              />
            </Grid>

            <Grid item xs={12}>
              <Typography
                variant="subtitle2"
                sx={{ mb: 1, fontWeight: 600, color: "#374151" }}
              >
                {t("payment.bankName")}
              </Typography>
              <TextField
                fullWidth
                size="small"
                value={bankAccount.bankName}
                onChange={(e) =>
                  handleBankAccountChange("bankName", e.target.value)
                }
                sx={{
                  "& .MuiOutlinedInput-root": {
                    borderRadius: 1,
                    "&:hover": {
                      "& .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#644980",
                      },
                    },
                    "&.Mui-focused": {
                      "& .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#644980",
                        borderWidth: 2,
                      },
                    },
                  },
                }}
              />
            </Grid>

            <Grid item xs={12}>
              <Typography
                variant="subtitle2"
                sx={{ mb: 1, fontWeight: 600, color: "#374151" }}
              >
                {t("payment.iban")}
              </Typography>
              <TextField
                fullWidth
                size="small"
                value={bankAccount.iban}
                onChange={(e) =>
                  handleBankAccountChange("iban", e.target.value)
                }
                sx={{
                  "& .MuiOutlinedInput-root": {
                    borderRadius: 1,
                    "&:hover": {
                      "& .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#644980",
                      },
                    },
                    "&.Mui-focused": {
                      "& .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#644980",
                        borderWidth: 2,
                      },
                    },
                  },
                }}
              />
            </Grid>

            <Grid item xs={12}>
              <Typography
                variant="subtitle2"
                sx={{ mb: 1, fontWeight: 600, color: "#374151" }}
              >
                {t("wallet.amountToWithdraw")}
              </Typography>
              <TextField
                fullWidth
                size="small"
                type="number"
                value={withdrawAmount}
                onChange={(e) => setWithdrawAmount(Number(e.target.value))}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    borderRadius: 1,
                    "&:hover": {
                      "& .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#644980",
                      },
                    },
                    "&.Mui-focused": {
                      "& .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#644980",
                        borderWidth: 2,
                      },
                    },
                  },
                }}
              />
            </Grid>
          </Grid>

          <Alert severity="info" sx={{ mt: 3, borderRadius: 1 }}>
            <Typography variant="body2">
              <strong>{t("wallet.withdrawnAmount")}:</strong> {AvailableCount}{" "}
              {t("currency")}
            </Typography>
          </Alert>
        </DialogContent>
        <DialogActions sx={{ p: 3, gap: 2 }}>
          <Button
            variant="outlined"
            onClick={handleClosePopup}
            sx={{ borderRadius: 1.5 }}
          >
            {t("actions.cancel")}
          </Button>
          <Button
            variant="contained"
            onClick={handleCreateTransform}
            disabled={loading}
            sx={{
              backgroundColor: "#644980",
              borderRadius: 1.5,
              px: 3,
              "&:hover": {
                backgroundColor: "#644980",
              },
            }}
          >
            {loading ? (
              <CircularProgress size={20} color="inherit" />
            ) : (
              t("actions.save")
            )}
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}

export default LandingPaymentBuyer;
